// Pilot Assistant Knowledge Bases Store Module
import PilotAssistantKnowledgeBases from 'dashboard/api/pilot/assistantKnowledgeBases';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const actions = mutations => ({
  get: async ({ commit }, { assistantId } = {}) => {
    commit(mutations.SET_UI_FLAG, { fetchingList: true });
    try {
      const response = await PilotAssistantKnowledgeBases.get({ assistantId });
      const records = response.data.payload || [];
      commit(mutations.SET, records);
      commit(mutations.SET_UI_FLAG, { fetchingList: false });
      return records;
    } catch (error) {
      commit(mutations.SET_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },

  create: async ({ commit }, { assistantId, knowledgeBaseId }) => {
    commit(mutations.SET_UI_FLAG, { creatingItem: true });
    try {
      const response = await PilotAssistantKnowledgeBases.create({
        assistantId,
        knowledgeBaseId,
      });
      commit(mutations.SET_UI_FLAG, { creatingItem: false });
      return response.data;
    } catch (error) {
      commit(mutations.SET_UI_FLAG, { creatingItem: false });
      return throwErrorMessage(error);
    }
  },

  delete: async ({ commit }, { assistantId, id }) => {
    commit(mutations.SET_UI_FLAG, { deletingItem: true });
    try {
      await PilotAssistantKnowledgeBases.delete({ assistantId, id });
      commit(mutations.DELETE, id);
      commit(mutations.SET_UI_FLAG, { deletingItem: false });
      return id;
    } catch (error) {
      commit(mutations.SET_UI_FLAG, { deletingItem: false });
      return throwErrorMessage(error);
    }
  },
});

export default createStore({
  name: 'PilotAssistantKnowledgeBases',
  API: PilotAssistantKnowledgeBases,
  actions,
});
